import API from '../../../../../services/api';

export const MODELOS_API = {
    get: async () => {
        return await API.get('/modelos').then(res => res.data);
    },
    new: async (modelo) => {
        return API.post('/modelos', modelo).then(res => res.data);
    },
    update: async (modelo) => {
        return API.put('/modelos', modelo).then(res => res.data);
    }
}
